module.exports = __webpack_public_path__ + "img/Picto_Form_03.40be42e3.svg";